import {getRoute} from "@common/vue/store/routes";

export async function duplicateTask(taskId) {
    const  api = getRoute('task-url', `duplicate-task?id=${taskId}`);
    return axios.post(api)
        .then(res => res.data)
        .catch(e => e);
}

export async function fetchConvertedRunId({convertTo, idsArr}) {
    const strIds = (idsArr || []).join(',');
    return axios.get(getRoute('task-url-api', 'get-run-ids'), {params:{[convertTo]: strIds}})
        .then(res => res.data)
        .catch(() => ([]));
}

export function openPlanUrlTasks(resultId) {
    window.store.commit('setPlanRunUrlId', resultId);
    resetState({resultId});
}

export function openPlanUrlNewTask(runId, urlId, service = '') {
    window.store.commit('setPlanRunUrlId', runId);
    resetState({runId, urlId, service});
}

export function openPlanUrlTask(resultId, taskId, streamId, runId, service, urlId) {
    window.store.commit('setPlanRunUrlId', resultId);
    resetState({resultId, taskId, streamId, runId, service, urlId});
}

export function setPlanAction(action) {
    window.Vue.nextTick(() => {
        window.store.commit('setAction', action);
    });
}

export function setPlanCRUDState(state) {
    const { resultId, taskId, streamId, runId, service, urlId } = state;
    // window.store.commit('setPlanRunUrlId', resultId);
    resetState({resultId, taskId, streamId, runId, service, urlId});
}

export function resetPlanCRUDState() {
    resetState({});
}

export function setPlanTaskCreated(val) {
    window.Vue.nextTick(() => {
        window.store.commit('setTaskCreated', val);
    });
}

export default {
    state: {
        taskCreated: false,
        action: null, //taskActionsVars
        resultId: '',
        taskId: '',
        urlId: '',
        streamId: '',
        runId: '',
        service: '',
    },

    mutations: {
        setAction(state, action) {
            state.action = action;
        },
        setTaskCreated(state, val) {
            state.taskCreated = val;
        },
        setPlanCRUDState(state, {resultId, taskId, urlId, streamId, runId, service}) {
            state.resultId = resultId || '';
            state.taskId = taskId || '';
            state.urlId = urlId || '';
            state.streamId = streamId || '';
            state.runId = runId || runId === 0 ? runId : '';
            state.service = service || service === null ? service : '';
        },
    }
};

function resetState(state) {
    window.store.commit('setPlanCRUDState', {});
    window.Vue.nextTick(() => {
        window.store.commit('setPlanCRUDState', state);
    });
}
